if (!customElements.get('wlsn-accordion')) {
    class WLSNAccordion extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                openClass: 'open',
                header: 'wlsn-accordion__header',
            };
            this.elements = {
                header: this.querySelector(`.${this.classes.header}`),
            }
            this.toggle = this.toggle.bind(this);
        }

        connectedCallback() {
            if (this.elements.header) {
                this.elements.header.addEventListener('click', this.toggle);
            }
        }

        disconnectedCallback() {
            if (this.elements.header) {
                this.elements.header.removeEventListener('click', this.toggle);
            }
        }

        toggle() {
            this.classList.toggle(this.classes.openClass);
        }
    }

    customElements.define('wlsn-accordion', WLSNAccordion);
}
